import { TOGGLE_EXPANDED } from 'expanded/constants'
import type { Action } from 'redux'

import { TOGGLE_LIST_DETAILS } from './constants'

export default function isListDetailsOpen(state = false, { type }: Action) {
  switch (type) {
    case TOGGLE_LIST_DETAILS:
      return !state
    case TOGGLE_EXPANDED:
      return false
    default:
      return state
  }
}
